<template>
    <div>
        <section class="blockElement between-footer notFound">
            <div class="container">
                <div class="row">
                <div class="col-12 text-center">
                    <div class="error-template">
                        <h1 class="heading">Oops!</h1>
                        <h2>404 Not Found</h2>
                        <div class="error-details">
                            Sorry, an error has occured, Requested page not found!
                        </div>
                        <div class="error-actions mt-4">
                            <router-link class="fin_btn darkBG mr-4" to="/">Take Me Home </router-link>
                            <!-- <router-link to="/contact-us" class="fin_btn redBG"> Contact Support </router-link> -->
                        </div>
                    </div>
                </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
export default {
	name: 'Not-Found',
        data() {
            return {

            }

        }
        
}
</script>



// WEBPACK FOOTER //
// src/components/website/shared/notFound.vue